<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15,4C15,4,12,4,12,4C11.45,4,11,4.45,11,5C11,5.55,11.45,6,12,6C12,6,12.59,6,12.59,6C12.59,6,8.8,9.780000000000001,8.8,9.780000000000001C8.8,9.780000000000001,5.45,8.11,5.45,8.11C5.45,8.11,5.45,8.120000000000001,5.45,8.120000000000001C5.31,8.05,5.16,8,5,8C4.84,8,4.69,8.05,4.56,8.11C4.56,8.11,4.56,8.1,4.56,8.1C4.56,8.1,0.56,10.1,0.56,10.1C0.56,10.1,0.56,10.11,0.56,10.11C0.23,10.280000000000001,0,10.61,0,11C0,11.55,0.45,12,1,12C1.16,12,1.31,11.95,1.44,11.89C1.44,11.89,1.44,11.9,1.44,11.9C1.44,11.9,5,10.120000000000001,5,10.120000000000001C5,10.120000000000001,8.55,11.9,8.55,11.9C8.55,11.9,8.55,11.89,8.55,11.89C8.69,11.95,8.84,12,9,12C9.28,12,9.53,11.89,9.71,11.71C9.71,11.71,14,7.41,14,7.41C14,7.41,14,8,14,8C14,8.55,14.45,9,15,9C15.55,9,16,8.55,16,8C16,8,16,5,16,5C16,4.45,15.55,4,15,4C15,4,15,4,15,4Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'TrendingUp',
} as DefineComponent
</script>
